import React, { useState } from "react";
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import axios from "axios";
import serverURL from "../config";
import ModalShell from "./ModalShell";

const AddUserModal = ({ closeAddUserModal, fetchUsers }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        role: 'candidate',
        id_number: '',
        institution: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleClose = () => {
        setFormData({ name: '', email: '', role: 'candidate', id_number: '', institution: '' });
        closeAddUserModal();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const trimmedName = formData.name.trim();
        const trimmedEmail = formData.email.trim();
        const trimmedIdNumber = formData.id_number.trim();
        const trimmedInstitution = formData.institution?.trim() || '';

        if (!trimmedName || !trimmedEmail || !formData.role) {
            toast.error('Please fill in all required fields.');
            return;
        }
        
        if (formData.role === 'candidate' && (!trimmedIdNumber || !trimmedInstitution)) {
            toast.error('ID Number and Institution are required for candidates.');
            return;
        }

        const token = localStorage.getItem('token');
        try {
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            const payload = {
                ...formData,
                name: trimmedName,
                email: trimmedEmail,
                id_number: trimmedIdNumber,
                institution: trimmedInstitution,
            };

            await axios.post(`${serverURL}/users`, payload, { headers });
            toast.success('User created successfully!');
            
            if (fetchUsers) {
                fetchUsers();
            }
            handleClose();
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'An unexpected error occurred.';
            toast.error(errorMessage);
            console.error('Error details:', error.response || error.message);
        }
    };

    return (
        <ModalShell title="Add User" onClose={handleClose}>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="user-name" className="block text-gray-700 text-sm font-bold mb-2">
                        Full Name <span className="text-red-500">*</span>
                    </label>
                    <input
                        id="user-name"
                        type="text"
                        name="name"
                        placeholder="Enter full name"
                        value={formData.name}
                        onChange={handleChange}
                        maxLength={100}
                        className={`w-full p-3 rounded-lg border bg-campus-bg text-campus-text-primary focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition-all ${!formData.name ? 'border-campus-error' : 'border-campus-border'}`}
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="user-email" className="block text-gray-700 text-sm font-bold mb-2">
                        Email Address <span className="text-red-500">*</span>
                    </label>
                    <input
                        id="user-email"
                        type="email"
                        name="email"
                        placeholder="Enter email address"
                        value={formData.email}
                        onChange={handleChange}
                        className={`w-full p-3 rounded-lg border bg-campus-bg text-campus-text-primary focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition-all ${!formData.email ? 'border-campus-error' : 'border-campus-border'}`}
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="user-id" className="block text-gray-700 text-sm font-bold mb-2">
                        Employee ID / Roll No {formData.role === 'candidate' && <span className="text-red-500">*</span>}
                    </label>
                    <input
                        id="user-id"
                        type="text"
                        name="id_number"
                        placeholder="Enter ID number"
                        value={formData.id_number}
                        onChange={handleChange}
                        className={`w-full p-3 rounded-lg border bg-campus-bg text-campus-text-primary focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition-all ${formData.role === 'candidate' && !formData.id_number ? 'border-campus-error' : 'border-campus-border'}`}
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="user-institution" className="block text-gray-700 text-sm font-bold mb-2">
                        Institution {formData.role === 'candidate' && <span className="text-red-500">*</span>}
                    </label>
                    <input
                        id="user-institution"
                        type="text"
                        name="institution"
                        placeholder="Enter institution"
                        value={formData.institution}
                        onChange={handleChange}
                        className={`w-full p-3 rounded-lg border bg-campus-bg text-campus-text-primary focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition-all ${formData.role === 'candidate' && !formData.institution ? 'border-campus-error' : 'border-campus-border'}`}
                    />
                </div>
                <div className="mb-6">
                    <label htmlFor="user-role" className="block text-gray-700 text-sm font-bold mb-2">
                        Role <span className="text-red-500">*</span>
                    </label>
                    <select
                        id="user-role"
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        className="w-full p-3 rounded-lg border border-campus-border bg-campus-bg text-campus-text-primary focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition-all"
                    >
                        <option value="candidate">Candidate</option>
                        <option value="interviewer">Interviewer</option>
                        <option value="admin">Admin</option>
                    </select>
                </div>
                <div className="flex justify-end pt-4 border-t border-campus-border">
                    <button
                        type="submit"
                        className="bg-campus-primary hover:bg-campus-primary-dark text-white px-6 py-2 rounded-lg font-medium transition-colors shadow-sm"
                    >
                        Save
                    </button>
                </div>
            </form>
        </ModalShell>
    );
};

AddUserModal.propTypes = {
    closeAddUserModal: PropTypes.func.isRequired,
    fetchUsers: PropTypes.func.isRequired,
};

export default AddUserModal;
